import { toString } from 'lodash';
import fp from 'lodash/fp';

export const sanitizeText = (text: string): string => {
  const sanitized = toString(text)
    /**
     * Convert HTML operators to Unicode. This is needed because NZCER
     * Online/CKEditor stores HTML in the database. We can potentionally remove
     * this code after NZCER Online is rebuilt:
     */
    .replace('&divide;', '\u{00F7}')
    .replace('&times;', '\u{00D7}')
    .replace('&ndash;', '\u{2212}')

    .replace('&#39;', "'")
    .replace(/<\/?[^>]+(>|$)/g, '')
    .replace(/&\S+;/gi, '');
  return sanitized;
};

// Note: these functions are mainly used for params parsing.
// I recommend refactoring them to be more specific to this use case so to avoid
// use of the any type.
export const getInteger =
  (path: string, defaultValue = 0) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (obj: any): number =>
    fp.flow(fp.getOr(defaultValue, path), fp.toInteger)(obj);

export const getNumber =
  (path: string, defaultValue = 0) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (obj: any): number =>
    fp.flow(fp.getOr(defaultValue, path), Number)(obj);

export const getString =
  (path: string, defaultValue = '') =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (obj: any): string =>
    fp.flow(fp.getOr(defaultValue, path), fp.toString)(obj);

export const getIdFromIri = (iri: string): number =>
  fp.flow(fp.split('/'), fp.last, fp.toInteger)(iri);
